import React from 'react';

interface LogoTextProps {
  logoSrc?: string;
  logoElement?: React.ReactNode;
  text?: string;
  color?: string;
  additionalText?:string;
}

const LogoText: React.FC<LogoTextProps> = ({ logoSrc, logoElement, text, color, additionalText }) => {
  const iconColor = color || 'var(--primary-color)';
  return (
    <div className="mb-2">
      <i style={{ color: iconColor }}>
        {logoElement ?? <img src={logoSrc} alt="Logo" />}
      </i>
      <span style={{ paddingLeft: '10px', color: 'black', fontFamily: "'Quicksand', sans-serif" }}>{text}</span>
      {additionalText && <span style={{ paddingLeft: '1px', color: iconColor, fontFamily: "'Quicksand', sans-serif" }}>{additionalText}</span>}
    </div>
  );
};

export default LogoText;
